var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"app":"","color":"primary","dark":""}},[_c('v-toolbar-title',[_vm._v("Départs Speed")]),_c('v-spacer'),_c('span',[_vm._v("v2.1")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }